import styled from 'styled-components/macro';
import { TABLET_BREAKPOINT } from '../../app/constants';

export const StyledSummary = styled.div<{ leftMenuCollapsed: boolean }>`
  @media (max-width: ${TABLET_BREAKPOINT}px) {
    display: block !important;
    padding-left: 0;

  }
  padding-left: ${(props) => (props.leftMenuCollapsed ? '306px' : '0')};
  position: relative;

  .summary-nav {
    border-bottom: 1px solid ${(props) => props.theme.grey.light};
    justify-content: space-between;
    padding: 0 20px 0 0;
  }
  .nav-tabs {
    flex: 1 0 auto;
    white-space: nowrap;
  }
  .classes-list {
    min-height: calc(100vh - 279px);
    position: ${(props) => (props.leftMenuCollapsed ? 'absolute' : 'static')};;
    width: ${(props) => (props.leftMenuCollapsed ? '306px' : 'auto')};;
    left: 0;
    top: 0;
    bottom: 0;
    padding: 0 2rem;
    @media (max-width: ${TABLET_BREAKPOINT}px) {
      margin-right: 0 !important;
      position: static;
      min-height: auto;
      width: 100%;
    }
  }
  .classes-list-inner {
    overflow-y: auto;

    height: 100%;
  }
  .results-block {
    position: relative;
    @media (max-width: ${TABLET_BREAKPOINT}px) {
      width: 100%;
    }
  }
  .back-button {
    @media (min-width: ${TABLET_BREAKPOINT}px) {
      display: none !important;
    }
  }
  .download-link {
    text-align: right;
    line-height: 1;
  }
`;
